//@flow
import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';

import CustomModal from '../../../../elements/CustomModal/CustomModal';
import {Typography} from '@material-ui/core';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {colors} from '../../../../assets/styles/colors';

import image1 from '../../../../assets/img/subscription-modal/sub-modal-1.jpg';
import image2 from '../../../../assets/img/subscription-modal/sub-modal-2.jpg';
import image3 from '../../../../assets/img/subscription-modal/sub-modal-3.jpg';
import plantProduct from '../../../../assets/img/subscription-modal/sub-modal-4.jpg';
import {Add, MonetizationOn, TrendingUp} from '@material-ui/icons';
import {useCurrentTier, useDaysElapsed} from '../../utils';
import {FREE_TRIAL_TIERS} from '../../../../entities';

const useStyles = makeStyles(theme => ({
  modal: {padding: '0', borderRadius: '16px', margin: 16},
  root: {
    maxWidth: 470,
  },
  information: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 4),
  },
  chip: {
    color: colors.grey700,
    background: colors.grey200,
    fontSize: '11px',
    fontWeight: 600,
    padding: theme.spacing(0.5, 1),
    borderRadius: '55px',
  },
  header: {
    padding: '0 1rem',

    [theme.breakpoints.up('sm')]: {
      padding: '0 3rem',
    },
  },
  title: {
    fontSize: 24,
    fontWeight: 600,
    textAlign: 'center',
  },
  description: {
    color: colors.grey700,
    fontSize: 16,
    textAlign: 'center',
    fontWeight: 400,
  },
  button: {
    background: '#FFC83B',
    color: '#210153',
    padding: theme.spacing(1.5, 10),
    fontSize: 16,

    '&:hover': {
      background: '#ffde89',
    },
  },
  gridContent: {
    background: 'linear-gradient(304.15deg, #18003D -8%, #2E0172 100%)',
    position: 'relative',
    width: '100%',
    display: 'grid',
    aspectRatio: '1 / 1',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: 'repeat(4, 70px)',
    padding: '1rem',
    borderRadius: '16px 16px 0 0',
    gap: '.5rem',

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      borderRadius: 'inherit',
    },

    '& [data-card]': {
      padding: '8px',
      borderRadius: '8px',
      background: 'white',
    },

    [theme.breakpoints.up('sm')]: {
      gridTemplateRows: 'repeat(6, 70px)',
    },

    [theme.breakpoints.up('sm')]: {
      gap: '1rem',
    },
  },
  notification: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  text: {
    fontSize: 9,
    fontWeight: 400,

    [theme.breakpoints.up('sm')]: {
      fontSize: 12,
    },
  },
  cardTitle: {
    fontSize: 9,
    fontWeight: 600,
    [theme.breakpoints.up('sm')]: {
      fontSize: 12,
    },
  },
  productCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    position: 'relative',
    flexDirection: 'row',
  },
  productData: {
    maxWidth: 45,
    [theme.breakpoints.up('sm')]: {
      maxWidth: '100%',
    },
  },
  productImage: {
    height: '100%',
    aspectRatio: '1 / 1',
    borderRadius: '8px',
  },
  addIcon: {
    background: '#3A3A49',
    borderRadius: '50%',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0.25rem',
    alignSelf: 'baseline',

    '& svg': {
      fontSize: '1rem',
    },
  },
  sales: {
    '& [data-green]': {
      color: colors.success,
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    },

    '& svg': {
      fontSize: '1rem',
    },

    '& [data-price]': {
      paddingTop: '0.25rem',
    },
  },
  head: {
    display: 'flex',
    gap: '.5rem',
    alignItems: 'center',
    borderBottom: 'solid 1px #E8E8ED',
    paddingBottom: '0.125rem',
    [theme.breakpoints.up('sm')]: {
      paddingBottom: '0.25rem',
    },
  },
  monetizationIcon: {
    width: 24,
    height: 24,
    color: 'white',
    borderRadius: '.5rem',
    background: colors.success,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  itemImage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px',
    '&[data-image-1]': {
      gridRow: '2/4',
      gridColumn: 2,
      [theme.breakpoints.up('sm')]: {
        gridRow: '2/6',
        gridColumn: 1,
      },
    },

    '&[data-image-2]': {
      gridRow: ' 2/5',

      [theme.breakpoints.up('sm')]: {
        gridRow: '1/4',
        gridColumn: 2,
      },
    },

    '&[data-image-3]': {
      display: 'none',

      [theme.breakpoints.up('sm')]: {
        display: 'flex',
        gridRow: '5/7',
        gridColumn: 2,
      },
    },
  },
}));

const SUB_MODAL_KEY = 'SUBSCRIPTION_MODAL';

export default function SubscriptionModal() {
  const currentTier = useCurrentTier();
  const daysElapsed = useDaysElapsed();
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
    localStorage.setItem(SUB_MODAL_KEY, 'true');
  };

  useEffect(() => {
    const isInFreeTrail = FREE_TRIAL_TIERS.includes(currentTier);
    const sevenDaysHaveElapsed = daysElapsed >= 7;
    const hasSeenModal = localStorage.getItem(SUB_MODAL_KEY);

    if (isInFreeTrail && sevenDaysHaveElapsed && !hasSeenModal) {
      setOpen(true);
    }
  }, [currentTier, daysElapsed]);

  return (
    <CustomModal
      open={open}
      handleCloseModal={handleClose}
      classes={{paper: classes.modal}}
    >
      <aside className={classes.root}>
        <div className={classes.information}>
          <span className={classes.chip}>PLAN ACTUAL: PRO+</span>
          <header className={classes.header}>
            <Typography className={classes.title}>
              ¡Suscríbete ahora! Elige TiendaDa
            </Typography>
          </header>
          <Typography className={classes.description}>
            No te preocupes, no te quitaremos tus días de regalo. El primer
            cobro se realizará una vez finalizado el periodo de pruebas.
          </Typography>

          <CustomButton
            className={classes.button}
            to="/tiers-list"
            onClick={handleClose}
          >
            Elegir Plan
          </CustomButton>
        </div>

        <div className={classes.gridContent}>
          <div className={classes.notification} data-card>
            <Typography className={classes.cardTitle}>Notificación</Typography>
            <Typography className={classes.text}>
              Tienes un nuevo pedido
            </Typography>
            <Typography className={classes.text}>{'#OR49A8874  🚀'}</Typography>
          </div>
          <div className={classes.productCard} data-card>
            <picture className={classes.productImage}>
              <img src={plantProduct} alt="Plant" />
            </picture>
            <div className={classes.productData}>
              <Typography className={classes.cardTitle}>
                Dracaena Trifasciata
              </Typography>
              <Typography className={classes.text}>s/ 86.00</Typography>
            </div>

            <div className={classes.addIcon}>
              <Add />
            </div>
          </div>
          <div className={classes.sales} data-card>
            <div className={classes.head}>
              <span className={classes.monetizationIcon}>
                <MonetizationOn />
              </span>
              <div className={classes.saleData}>
                <Typography className={classes.text}>Ventas Totales</Typography>
                <Typography className={classes.text} data-green>
                  <TrendingUp /> 8.15%
                </Typography>
              </div>
            </div>
            <Typography className={classes.cardTitle} data-price>
              S/ 23,494.00
            </Typography>
          </div>
          <picture className={classes.itemImage} data-image-1>
            <img src={image1} alt="Two people showing their work" />
          </picture>
          <picture className={classes.itemImage} data-image-2>
            <img src={image2} alt="man checking his tablet" />
          </picture>
          <picture className={classes.itemImage} data-image-3>
            <img src={image3} alt="Woman showing her products" />
          </picture>
        </div>
      </aside>
    </CustomModal>
  );
}
